import Vue from "vue";
import Router from "vue-router";

import Startseite from "./views/Startseite.vue";
import Produkte from "./views/Produkte.vue";
import AluZaun from "./views/AluZaun.vue";
import Balkon from "./views/Balkon.vue";
import Carport from "./views/Carport.vue";
import Geländer from "./views/Geländer.vue";
import Klappläden from "./views/Klappläden.vue";
import Renofloor from "./views/Renofloor.vue";
import Sichtschutz from "./views/Sichtschutz.vue";
import Stahlzaun from "./views/Stahlzaun.vue";
import Überdachung from "./views/Überdachung.vue";
import Vordach from "./views/Vordach.vue";

import Classic from "./views/balkonviews/Classic.vue";
import Edelstahl from "./views/balkonviews/Edelstahl.vue";
import Frühling from "./views/balkonviews/Frühling.vue";
import Karibik from "./views/balkonviews/Karibik.vue";
import Kristall from "./views/balkonviews/Kristall.vue";
import London from "./views/balkonviews/London.vue";
import Standard from "./views/balkonviews/Standard.vue";
import Wien from "./views/balkonviews/Wien.vue";
import WienJunior from "./views/balkonviews/WienJunior.vue";

import Vertriebspartner from "./views/Vertriebspartner.vue";
import Veranstaltungen from "./views/Veranstaltungen.vue";
import Ausstellung from "./views/Ausstellung.vue"
import Impressum from "./views/Impressum.vue";
import Datenschutz from "./views/Datenschutz.vue";

import About from "./layout/about.vue";
import Contact from "./layout/contact.vue";
import Navbar from "./layout/Navbar.vue";
import Footer from "./layout/Footer.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "startseite",
      components: { default: Startseite, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte",
      name: "produkte",
      components: { default: Produkte, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Alu-Zaun",
      name: "AluZaun",
      components: { default: AluZaun, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Balkon",
      name: "Balkon",
      components: { default: Balkon, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Balkon/Classic",
      name: "Classic",
      components: { default: Classic, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Balkon/Edelstahl",
      name: "Edelstahl",
      components: { default: Edelstahl, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Balkon/Frühling",
      name: "Frühling",
      components: { default: Frühling, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Balkon/Karibik",
      name: "Karibik",
      components: { default: Karibik, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Balkon/Kristall",
      name: "Kristall",
      components: { default: Kristall, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Balkon/London",
      name: "London",
      components: { default: London, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Balkon/Standard",
      name: "Standard",
      components: { default: Standard, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Balkon/Wien",
      name: "Wien",
      components: { default: Wien, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Balkon/WienJunior",
      name: "WienJunior",
      components: { default: WienJunior, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Carport",
      name: "Carport",
      components: { default: Carport, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Geländer",
      name: "Geländer",
      components: { default: Geländer, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Klappläden",
      name: "Klappläden",
      components: { default: Klappläden, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Renofloor",
      name: "Renofloor",
      components: { default: Renofloor, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Sichtschutz",
      name: "Sichtschutz",
      components: { default: Sichtschutz, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Stahlzaun",
      name: "Stahlzaun",
      components: { default: Stahlzaun, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Überdachung",
      name: "Überdachung",
      components: { default: Überdachung, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/produkte/Vordach",
      name: "Vordach",
      components: { default: Vordach, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/vertriebspartner",
      name: "vertriebspartner",
      components: { default: Vertriebspartner, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
{
      path: "/veranstaltungen",
      name: "veranstaltungen",
      components: { default: Veranstaltungen, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },

    {
      path: "/ausstellung",
      name: "ausstellung",
      components: { default: Ausstellung, header: Navbar, about: About, contact: Contact, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/impressum",
      name: "impressum",
      components: { default: Impressum, header: Navbar, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    },
    {
      path: "/datenschutz",
      name: "datenschutz",
      components: { default: Datenschutz, header: Navbar, footer: Footer },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: "black" }
      }
    }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
